
import meImg from '../../Assets/myImg.png'
import resume from '../../Assets/Shivam_CV-long-final.pdf'
import { faFacebook,faSquareInstagram,faGithub,faLinkedin} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typewriter from 'typewriter-effect';
export const Header = () => {
  return (
    <div  className=" bg-gradient-to-r from-sky-400 to-indigo-900 flex md:gap-8 lg:h-screen p-4  " id='home'>
      <div className=' flex flex-col gap-1 md:gap-4 w-3/5  justify-center align-middle relative '>
          <div className=' flex justify-center'>
             <div className='flex flex-col  gap-1 md:gap-2 text-white md:ml-6'>
              <span  className='text-sm md:text-4xl lg:text-6xl '>Hey! This is</span>
             <span className=' text-xl  md:text-5xl lg:text-8xl font-bold'>Shivam Sharma</span>
             <span className=' text-sm md:text-2xl lg:text-3xl '> <Typewriter
        options={{
          strings: ['React Developer', 'Welcome to my portfolio!'],
          autoStart: true,
          loop: true,
          delay: 75,
          deleteSpeed: 50,
        }}
      /></span>         
             </div>
          </div>
          <div className='text-blue flex gap-2 md:gap-5 justify-start ml-3 lg:ml-28 md:ml-16'>
            <span ><a href="https://www.facebook.com/sagar.dhiman.3538/?fref=nf&pn_ref=story&_rdr" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebook} className='text-white  md:text-2xl text-1xl lg:text-4xl hover:scale-110'/></a></span>
            <span ><a href="https://www.instagram.com/shivamshr01/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faSquareInstagram} className='text-white  md:text-2xl text-1xl lg:text-4xl hover:scale-110'/></a></span>
            <span > <a href="https://github.com/shivamshr01" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faGithub} className='text-white  text-1xl  md:text-2xl lg:text-4xl hover:scale-110'/></a></span>
            <span ><a href="https://www.linkedin.com/in/shivam-sharma-373a15246" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedin} className='text-white text-1xl md:text-2xl lg:text-4xl hover:scale-110' /></a></span>
          </div>
           <button className='text-white text-[8px] md:text-xl md:font-bold border-2 border-white rounded-3xl md:p-2 p-1 w-max bg-inherit md:ml-28 ml-4  shadow-sm md:shadow-md shadow-sky-300'>
              <a href={resume} download='resume'>Download CV</a>
           </button>
      </div>
      <div className='w-2/5'>
          <img src={meImg} alt="" className=' flex justify-center h-9/10 object-contain mt-8  ' />
      </div>
    </div>
  )
}